import { RESOLVABLE_TREE_PRIVATE } from './privates';
import { ConstructResolvableTree } from './constructor';
export function ResolvableTreeGetChildren(instance) {
    return instance[RESOLVABLE_TREE_PRIVATE].children;
}
export function ResolvableTreeResolve(instance, options) {
    return instance[RESOLVABLE_TREE_PRIVATE].resolve.call(instance, options);
}
var ResolvableTree = (function () {
    function ResolvableTree(options) {
        ConstructResolvableTree(this, options);
    }
    Object.defineProperty(ResolvableTree.prototype, "children", {
        get: function () {
            return ResolvableTreeGetChildren(this);
        },
        enumerable: true,
        configurable: true
    });
    ResolvableTree.prototype.resolve = function (options) {
        return ResolvableTreeResolve(this, options);
    };
    return ResolvableTree;
}());
export { ResolvableTree };
//# sourceMappingURL=implementation.js.map